import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'kenteken'
})
export class KentekenPipe implements PipeTransform {
    transform(input: string): string {
        if (input === undefined) {
            return;
        }

        // @TODO: Android fallback

        let output = '',
            value: string;
        const parts = (input || '').toUpperCase().match(/([\d]{1,4}|[A-Za-z]{1,4})/g);

        for (const index in parts) {
            if (parts.hasOwnProperty(index)) {
                value = parts[index];

                if (value.length === 4) {
                    value = value.substr(0, 2) + '-' + value.substr(2, 2);
                }

                output += value;

                if (Number(index) < (parts.length - 1)) {
                    output += '-';
                }
            }
        }

        return output.substr(0, 8);

    }
}
